function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgCircleWarningOutline = function SvgCircleWarningOutline(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Outlined Circle Warning' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("path", {
    d: "M24,46 C11.869,46 2,36.131 2,24 C2,11.869 11.869,2 24,2 C36.131,2 46,11.869 46,24 C46,36.131 36.131,46 24,46 M24,0 C10.767,0 0,10.767 0,24 C0,37.233 10.767,48 24,48 C37.233,48 48,37.233 48,24 C48,10.767 37.233,0 24,0"
  }), React.createElement("path", {
    d: "M24,31 C25.105,31 26,31.896 26,33 C26,34.104 25.105,35 24,35 C22.895,35 22,34.104 22,33 C22,31.896 22.895,31 24,31 Z M25.5,14 L25,28 L23,28 L22.5,14 L25.5,14 Z"
  }));
};

SvgCircleWarningOutline = pure(SvgCircleWarningOutline);
SvgCircleWarningOutline.displayName = 'SvgCircleWarningOutline';
export default SvgCircleWarningOutline;